import { api } from '@/shared/api/client'
import type { Account, CompanyRequest, Company, LoginRequest, RegisterRequest } from '@/shared/api/types'

export const sessionApi = {
  me: (signal?: AbortSignal) => api.get<Account>('/me', signal),
  login: (body: LoginRequest) => api.post<Account>('/auth/login', body),
  register: (body: RegisterRequest) => api.post<Account>('/auth/register', body),
  logout: () => api.post<void>('/auth/logout'),
  updateCompany: (body: CompanyRequest) => api.put<Company>('/company', body),
}
